import {
  ApiCartDeleteCartEntryRequestedAction,
  apiCartDeleteCartEntryFailed,
  apiCartDeleteCartEntrySucceeded
} from '../../../api/cart/deleteCartEntryApi';
import { call, put } from 'typed-redux-saga';
import deleteCartEntryAction, {
  DeleteCartEntryActionInput
} from '@spa/lib/actions/cart/deleteCartEntryAction';
import { DeleteCartEntryResult } from '@spa/lib/graphql/cart/deleteCartEntry';

function* deleteCartEntrySaga({
  payload: { entryId, customOrderType, parentActionId, actionId: requestedActionId }
}: ApiCartDeleteCartEntryRequestedAction): Generator {
  try {
    const input: DeleteCartEntryActionInput = { customOrderType, entryId };
    const result: DeleteCartEntryResult = yield* call(
      deleteCartEntryAction,
      'deleteCartEntryAction',
      input
    );

    yield* put(
      apiCartDeleteCartEntrySucceeded({
        requestedActionId,
        parentActionId,
        result,
        cartId: result.cart.code,
        entryId
      })
    );
  } catch {
    yield* put(apiCartDeleteCartEntryFailed({ requestedActionId, parentActionId }));
  }
}

export default deleteCartEntrySaga;
